import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as Styles from "../styles";

interface ActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  isShared: boolean;
  onCreateTask: () => void;
  onHistoric: () => void;
  onTransfer: () => void;
  onShare: () => void;
  onDisqualify: () => void;
  disableTransferShare?: boolean;
}

export const ActionsMenu: React.FC<ActionsMenuProps> = ({
  anchorEl,
  open,
  onClose,
  isShared,
  onCreateTask,
  onHistoric,
  onTransfer,
  onShare,
  onDisqualify,
  disableTransferShare = false,
}) => (
  <Styles.Menu anchorEl={anchorEl} open={open} onClose={onClose}>
    <Styles.MenuItem
      onClick={() => {
        onCreateTask();
        onClose();
      }}
    >
      Agendar tarefa
    </Styles.MenuItem>
    <Styles.MenuItem
      onClick={() => {
        onHistoric();
        onClose();
      }}
    >
      Histórico
    </Styles.MenuItem>
    {!isShared && (
      <div>
        <Styles.MenuItem
          disabled={disableTransferShare}
          onClick={() => {
            if (disableTransferShare) return;
            onTransfer();
            onClose();
          }}
        >
          Transferir
        </Styles.MenuItem>
        <Styles.MenuItem
          disabled={disableTransferShare}
          onClick={() => {
            if (disableTransferShare) return;
            onShare();
            onClose();
          }}
        >
          Compartilhar
        </Styles.MenuItem>
        <Styles.MenuItem
          onClick={() => {
            onDisqualify();
            onClose();
          }}
        >
          Desqualificar
        </Styles.MenuItem>
      </div>
    )}
  </Styles.Menu>
);

interface CheckedActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  checkedCount: number;
  onTransfer: () => void;
  onShare: () => void;
  onAlterarEtiquetas: () => void;
  onAlterarProdutos: () => void;
  onEnviarWhatsAppMassa: () => void;
  showEnviarWhatsAppMassa?: boolean;
  disableTransferShare?: boolean;
}

export const CheckedActionsMenu: React.FC<CheckedActionsMenuProps> = ({
  anchorEl,
  open,
  onClose,
  checkedCount,
  onTransfer,
  onShare,
  onAlterarEtiquetas,
  onAlterarProdutos,
  onEnviarWhatsAppMassa,
  showEnviarWhatsAppMassa = true,
  disableTransferShare = false,
}) => {
  const requireSelection = (action: () => void) => {
    if (checkedCount > 0) {
      action();
      onClose();
    } else {
      // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
      const { toast } = require("react-toastify");
      toast.warning("Selecione ao menos um lead para prosseguir com a ação!");
    }
  };

  return (
    <Styles.Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      <Styles.MenuItem
        disabled={disableTransferShare}
        onClick={() => {
          if (disableTransferShare) return;
          requireSelection(onTransfer);
        }}
      >
        Transferir
      </Styles.MenuItem>
      <Styles.MenuItem
        disabled={disableTransferShare}
        onClick={() => {
          if (disableTransferShare) return;
          requireSelection(onShare);
        }}
      >
        Compartilhar
      </Styles.MenuItem>
      <Styles.MenuItem onClick={() => requireSelection(onAlterarEtiquetas)}>
        Alterar Etiquetas
      </Styles.MenuItem>
      <Styles.MenuItem onClick={() => requireSelection(onAlterarProdutos)}>
        Alterar Produtos
      </Styles.MenuItem>
      {showEnviarWhatsAppMassa && (
        <Styles.MenuItem
          onClick={() => requireSelection(onEnviarWhatsAppMassa)}
        >
          Enviar WhatsApp em Massa
        </Styles.MenuItem>
      )}
    </Styles.Menu>
  );
};

interface EtiquetaMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  tags: any;
  onAlterarEtiqueta: (idEtiqueta: string) => void;
}

export const EtiquetaMenu: React.FC<EtiquetaMenuProps> = ({
  anchorEl,
  open,
  onClose,
  tags,
  onAlterarEtiqueta,
}) => (
  <Styles.Menu anchorEl={anchorEl} open={open} onClose={onClose}>
    <Styles.MenuItem onClick={() => onAlterarEtiqueta("")}>
      <div
        style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}
      >
        <p
          style={{
            padding: "2px 6px",
            color: "black",
            width: "fit-content",
            maxWidth: "100px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 12,
            borderRadius: 8,
          }}
        >
          Sem etiqueta
        </p>
      </div>
    </Styles.MenuItem>
    {tags?.etiquetasCorretor?.map(
      (item: { id: string; nome: string; cor: string }) => (
        <Styles.MenuItem
          key={item?.id}
          onClick={() => onAlterarEtiqueta(item?.id)}
        >
          <Tooltip
            followCursor
            title={item?.nome ?? "Sem informação da etiqueta"}
            placement="top-start"
            arrow
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
              }}
            >
              <p
                style={{
                  padding: "2px 6px",
                  backgroundColor: item?.cor ?? "gray",
                  color: "white",
                  width: "fit-content",
                  maxWidth: "65px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: 12,
                  borderRadius: 8,
                }}
              >
                {item?.nome}
              </p>
            </div>
          </Tooltip>
        </Styles.MenuItem>
      )
    )}
  </Styles.Menu>
);
